<template>
  <div class="fill-width">
    <b-container class="m-0 p-0" fluid v-if="getMobileLayout">
      <b-row class="pt-3" no-gutters>
        <b-col cols="12" class="d-flex justify-content-end pt-2">
          <img src="@/assets/images/shaparak-icon.png" height="40" width="40" />
        </b-col>
      </b-row>
      <b-row>
        <b-col
          v-if="shaparakCommissionFeeText"
          cols="12"
          class="new-title-color font-size-small font-weight-bold"
        >
          <p v-html="shaparakCommissionFeeText"></p>
        </b-col>
        <b-col
          cols="12"
          class="new-title-color font-size-small pb-1 font-weight-bold"
        >
          {{ $translate("cardNumber") }}:
        </b-col>
        <b-col cols="12" class="pb-4 new-subtext-color font-size-xs">
          {{ $translate("enter16DigitCardNumber") }}
        </b-col>
      </b-row>
      <b-row class="mb-0 pb-3 direction-ltr">
        <b-row
          no-gutters
          class="direction-ltr m-0 p-0"
          v-if="!isCreditCardReceivedFromServer"
        >
          <b-col cols="12">
            <div class="input-group p-0">
              <div class="input-group-prepend" v-if="bankImageSource">
                <span class="input-group-text fill-height">
                  <img
                    :src="bankImageSource"
                    height="25"
                    width="25"
                    v-if="checkIfInputNotEmpty"
                  />
                </span>
              </div>
              <input
                v-for="(key, i) in creditCardInfo"
                required
                @paste="onCreditCardPaste($event, 'creditCardInfo')"
                @input="handleAutoFocus(i)"
                :id="`shaparak-credit-card-input-key${i}`"
                :key="i"
                v-model="key.value"
                pattern="\d*"
                inputmode="numeric"
                class="col-2 form-control new-form-control mx-1"
                placeholder="0000"
                v-mask="'####'"
              />
            </div>
          </b-col>
        </b-row>
        <transition
          name="animate__fadeIn"
          :duration="200"
          enter-active-class="animate__animated animate__fadeIn "
          leave-active-class="animate__animated animate__fadeOut "
          appear
        >
          <b-col
            cols="12"
            class="d-flex justify-content-end align-items-center pt-3"
            v-if="
              !secondContainerVisibility && creditCardInfo[3].value.length === 4
            "
          >
            <span class="alert-text font-size-xs font-weight-bold">
              {{ $translate("invalidCardNumber") }}
            </span>
          </b-col>
        </transition>
      </b-row>
      <b-row>
        <b-col
          cols="12"
          class="pb-1 new-title-color font-size-small font-weight-bold"
        >
          {{ $translate("mobilePhone") }}:
        </b-col>
        <b-col cols="12" class="pb-1 new-subtext-color font-size-xs">
          {{ $translate("enterMobilePhoneNumber") }}.
        </b-col>
      </b-row>
      <b-row cols="12 input-group direction-ltr m-0 pb-3">
        <b-form-input
          id="mobile-number-input"
          name="mobile-number-input"
          placeholder="09000000000"
          class="col-2 form-control new-form-control mx-1 py-2"
          pattern="\d*"
          inputmode="numeric"
          required
          v-model="mobileNumber"
          v-mask="'###########'"
          :state="mobileNumberValidation"
          :readonly="isPhoneNumberReceivedFromServer"
        ></b-form-input>
      </b-row>
      <b-row class="pt-1">
        <b-col
          cols="12"
          class="pb-1 new-title-color font-size-small font-weight-bold"
        >
          {{ $translate("payingAmount") }}
        </b-col>
      </b-row>
      <!--          if the paying amount was available on store -->
      <b-row
        cols="12"
        class="input-group direction-rtl m-0 pb-3"
        v-if="
          !isShetabAmountsReceivedFromServer ||
          (isShetabAmountsReceivedFromServer &&
            getPayingAmount &&
            getPayingAmount.split(',').length > 1)
        "
      >
        <b-form-select
          class="form-control new-form-control mx-1 py-2"
          v-model="selectedAmount"
          :options="options"
          required
        ></b-form-select>
      </b-row>
      <b-row
        cols="12"
        class="input-group direction-rtl m-0 pb-3"
        v-if="
          isShetabAmountsReceivedFromServer &&
          getPayingAmount &&
          getPayingAmount.split(',').length === 1
        "
      >
        <input
          :value="handleShaparakFixAmount()"
          readonly
          :class="{ secondVersionInputs: getVersion === 'v2' }"
          class="col-2 form-control mx-1 font-size-medium-small font-weight-bold"
        />
      </b-row>
      <b-row class="pb-4">
        <b-col cols="4">
          <button
            type="button"
            class="new-version-decline-button"
            @click="cancelPayment"
          >
            <span class="button-texts">
              {{ $translate("cancel") }}
            </span>
          </button>
        </b-col>
        <b-col cols="8">
          <button
            type="button"
            class="go-to-next-button"
            id="next-step-button"
            @click="submitInfo"
          >
            <b-row class="fill-width d-flex items-center">
              <b-col cols="10"
                ><span class="button-texts">
                  {{ $translate("nextStep") }}</span
                ></b-col
              >
              <b-col cols="2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="25"
                  height="25"
                  fill="currentColor"
                  class="bi bi-arrow-left-short"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5z"
                  />
                </svg>
              </b-col>
            </b-row>
          </button>
        </b-col>
      </b-row>
    </b-container>
    <b-container class="m-0 p-0" fluid v-else-if="!getMobileLayout">
      <b-row>
        <b-col cols="7">
          <b-row class="pt-3" no-gutters>
            <b-col cols="12" class="d-flex justify-content-end pt-2">
              <img
                src="@/assets/images/shaparak-icon.png"
                height="40"
                width="40"
              />
            </b-col>
          </b-row>
          <b-row>
            <b-col
              v-if="shaparakCommissionFeeText"
              cols="12"
              class="new-title-color font-size-small pb-1 font-weight-bold"
            >
              <p v-html="shaparakCommissionFeeText"></p>
            </b-col>
            <b-col
              cols="12"
              class="new-title-color font-size-small pb-1 font-weight-bold"
            >
              {{ $translate("cardNumber") }}:
            </b-col>
            <b-col cols="12" class="pb-4 new-subtext-color font-size-xs">
              {{ $translate("enter16DigitCardNumber") }}
            </b-col>
          </b-row>
          <b-row class="mb-0 pb-3 direction-ltr">
            <b-row
              no-gutters
              class="direction-ltr m-0 p-0"
              v-if="!isCreditCardReceivedFromServer"
            >
              <b-col cols="12">
                <div class="input-group p-0">
                  <div class="input-group-prepend" v-if="bankImageSource">
                    <span class="input-group-text fill-height">
                      <img
                        :src="bankImageSource"
                        height="25"
                        width="25"
                        v-if="checkIfInputNotEmpty"
                      />
                    </span>
                  </div>
                  <input
                    v-for="(key, i) in creditCardInfo"
                    required
                    @paste="onCreditCardPaste($event, 'creditCardInfo')"
                    @input="handleAutoFocus(i)"
                    :id="`shaparak-credit-card-input-key${i}`"
                    :key="i"
                    v-model="key.value"
                    pattern="\d*"
                    inputmode="numeric"
                    class="col-2 form-control new-form-control mx-1"
                    placeholder="0000"
                    v-mask="'####'"
                  />
                </div>
              </b-col>
            </b-row>
            <transition
              name="animate__fadeIn"
              :duration="200"
              enter-active-class="animate__animated animate__fadeIn "
              leave-active-class="animate__animated animate__fadeOut "
              appear
            >
              <b-col
                cols="12"
                class="d-flex justify-content-end align-items-center pt-3"
                v-if="
                  !secondContainerVisibility &&
                  creditCardInfo[3].value.length === 4
                "
              >
                <span class="alert-text font-size-xs font-weight-bold">
                  {{ $translate("invalidCardNumber") }}
                </span>
              </b-col>
            </transition>
          </b-row>
          <b-row>
            <b-col
              cols="12"
              class="pb-1 new-title-color font-size-small font-weight-bold"
            >
              {{ $translate("mobilePhone") }}:
            </b-col>
            <b-col cols="12" class="pb-1 new-subtext-color font-size-xs">
              {{ $translate("enterMobilePhoneNumber") }}.
            </b-col>
          </b-row>
          <b-row cols="12 input-group direction-ltr m-0 pb-3">
            <b-form-input
              id="mobile-number-input"
              name="mobile-number-input"
              placeholder="09000000000"
              class="col-2 form-control new-form-control mx-1"
              pattern="\d*"
              inputmode="numeric"
              required
              v-model="mobileNumber"
              v-mask="'###########'"
              :state="mobileNumberValidation"
              :readonly="isPhoneNumberReceivedFromServer"
            ></b-form-input>
          </b-row>
        </b-col>
        <b-col cols="5" class="d-flex justify-content-center flex-column">
          <b-row class="pt-1">
            <b-col
              cols="12"
              class="pb-1 new-title-color font-size-small font-weight-bold"
            >
              {{ $translate("payingAmount") }}
            </b-col>
          </b-row>
          <!--          if the paying amount was available on store -->
          <b-row
            cols="12"
            class="input-group direction-rtl m-0 pb-3"
            v-if="
              !isShetabAmountsReceivedFromServer ||
              (isShetabAmountsReceivedFromServer &&
                getPayingAmount &&
                getPayingAmount.split(',').length > 1)
            "
          >
            <b-form-select
              class="form-control new-form-control mx-1"
              v-model="selectedAmount"
              :options="options"
              required
            ></b-form-select>
          </b-row>
          <b-row
            cols="12"
            class="input-group direction-rtl m-0 pb-3"
            v-if="
              isShetabAmountsReceivedFromServer &&
              getPayingAmount &&
              getPayingAmount.split(',').length === 1
            "
          >
            <input
              :value="handleShaparakFixAmount()"
              readonly
              :class="{ secondVersionInputs: getVersion === 'v2' }"
              class="col-2 form-control mx-1 font-size-medium-small font-weight-bold"
            />
          </b-row>
          <b-col
            cols="12"
            class="d-flex justify-content-center align-items-center px-0"
          >
            <b-row class="pb-4 fill-width">
              <b-col cols="4">
                <button
                  type="button"
                  class="new-version-decline-button"
                  @click="cancelPayment"
                >
                  <span class="button-texts">
                    {{ $translate("cancel") }}
                  </span>
                </button>
              </b-col>
              <b-col cols="8" class="pl-0">
                <button
                  type="button"
                  class="go-to-next-button"
                  id="next-step-button"
                  @click="submitInfo"
                >
                  <b-row class="fill-width">
                    <b-col cols="10" class="d-lg-flex justify-content-lg-center"
                      ><span class="button-texts">
                        {{ $translate("nextStep") }}</span
                      ></b-col
                    >
                    <b-col
                      cols="2"
                      class="p-0 d-flex justify-content-center align-items-center"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        fill="currentColor"
                        class="bi bi-arrow-left-short"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5z"
                        />
                      </svg>
                    </b-col>
                  </b-row>
                </button>
              </b-col>
            </b-row>
          </b-col>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { createShaparakTransactionMixin } from "@/mixins/ShaparakMixins/CreateShaparakTransactionMixin";
import { mapGetters } from "vuex";
export default {
  name: "CreateShaparakTransactionNewVersion",
  mixins: [createShaparakTransactionMixin],
  computed: {
    ...mapGetters(["getMobileLayout"]),
  },
};
</script>

<style scoped>
.decline-button {
  width: 100%;
  height: 40px;
  border-radius: 10px;
  border: 1px solid black;
  background-color: transparent;
}

.go-to-next-button {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 40px;
  border: none !important;
  border-radius: 10px;
  background-color: dodgerblue;
  color: white;
}

</style>
